module.exports = __webpack_public_path__ + "static/media/new-new-tensorflow.99f73914.svg";